import * as React from 'react';
import classNames from 'classnames';
import styles from './Dot.module.scss';

export interface Props
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'> {
  color: string;
}

export const Dot: React.FunctionComponent<Props> = ({
  className,
  style,
  color,
  ...htmlElementProps
}) => (
  <span
    className={classNames(styles.dot, className)}
    style={{ backgroundColor: color, ...style }}
    data-testid="dot"
    {...htmlElementProps}
  />
);

export default Dot;
